import type { AppGlueAny } from "./AppGlueAny";

export interface IDataMemberAccessor {
    list: boolean;

    get(fromValue: object): AppGlueAny;

    set(onValue: AppGlueAny, value: AppGlueAny): void;
}

export class PropertyDataMemberAccessor implements IDataMemberAccessor {
    propertyName: string;
    list: boolean = false;

    constructor(propertyName: string, list?: boolean) {
        this.propertyName = propertyName;

        if (list) {
            this.list = list;
        }
    }

    get(fromValue: object): AppGlueAny {
        if (Array.isArray(fromValue)) {
            let output: AppGlueAny[] = [];

            for (let v of fromValue) {
                let vv = Reflect.get(v, this.propertyName);
                if (Array.isArray(vv)) {
                    // combine arrays
                    for (let vvVal of vv) {
                        output.push(vvVal);
                    }
                } else {
                    output.push(vv);
                }
            }

            return output;
        }
        return Reflect.get(fromValue, this.propertyName);
    }

    set(onValue: AppGlueAny, value: AppGlueAny): void {
        Reflect.set(onValue, this.propertyName, value);
    }
}

export class ArrayItemDataMemberAccessor implements IDataMemberAccessor {
    index: number;
    list: boolean = false;

    constructor(index: number, list?: boolean) {
        this.index = index;

        if (list) this.list = list;
    }

    get(fromValue: object): AppGlueAny {
        if (Array.isArray(fromValue)) {
            if (fromValue.length <= this.index) throw new Error("fetching invalid array item");

            return fromValue[this.index];
        } else {
            throw new Error("value is not an array");
        }
    }

    set(onValue: AppGlueAny, value: AppGlueAny): void {
        if (Array.isArray(onValue)) {
            if (onValue.length <= this.index) throw new Error("index is out of range");

            onValue[this.index] = value;
        } else {
            throw new Error("value is not an array");
        }
    }
}

export class ArrayFirstDataMemberAccessor implements IDataMemberAccessor {
    list: boolean = true;

    get(fromValue: object): AppGlueAny {
        if (Array.isArray(fromValue)) {
            if (fromValue.length === 0) return null;

            return fromValue[0];
        } else {
            throw new Error("value is not an array");
        }
    }

    set(onValue: AppGlueAny, value: AppGlueAny): void {
        if (Array.isArray(onValue)) {
            if (onValue.length === 0) throw new Error("index is out of range");

            onValue[0] = value;
        } else {
            throw new Error("value is not an array");
        }
    }
}

export class ArrayLastDataMemberAccessor implements IDataMemberAccessor {
    list: boolean = true;

    get(fromValue: object): AppGlueAny {
        if (Array.isArray(fromValue)) {
            if (fromValue.length === 0) return null;

            return fromValue[fromValue.length - 1];
        } else {
            throw new Error("value is not an array");
        }
    }

    set(onValue: AppGlueAny, value: AppGlueAny): void {
        if (Array.isArray(onValue)) {
            if (onValue.length === 0) throw new Error("index is out of range");

            onValue[onValue.length - 1] = value;
        } else {
            throw new Error("value is not an array");
        }
    }
}

export class ArrayAddDataMemberAccessor implements IDataMemberAccessor {
    list: boolean = true;

    get(fromValue: object): AppGlueAny {
        if (Array.isArray(fromValue)) {
            if (fromValue.length === 0) return null;

            return fromValue[fromValue.length - 1];
        } else {
            throw new Error("value is not an array");
        }
    }

    set(onValue: AppGlueAny, value: AppGlueAny): void {
        if (Array.isArray(onValue)) {
            onValue.push(value);
        } else {
            throw new Error("value is not an array");
        }
    }
}

export class ArrayAddFirstDataMemberAccessor implements IDataMemberAccessor {
    list: boolean = true;

    get(fromValue: object): AppGlueAny {
        if (Array.isArray(fromValue)) {
            if (fromValue.length === 0) return null;

            return fromValue[0];
        } else {
            throw new Error("value is not an array");
        }
    }

    set(onValue: AppGlueAny, value: AppGlueAny): void {
        if (Array.isArray(onValue)) {
            onValue.unshift(value);
        } else {
            throw new Error("value is not an array");
        }
    }
}
